import axios from '@/lib/axios';
import CheckoutForm from './CheckoutForm';
import OrderSummary from './OrderSummary';
import { useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from '@/lib/redux/hooks';
import { useRouter } from 'next/navigation';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { clearCart } from '@/lib/redux/features/cart';

const CheckoutWrapper = ({ address, cartSummary, mutate }: any) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { items: cart_list, loading: cartLoading } = useAppSelector(
    (state) => state.cart
  );
  const [checkedCart, setCheckedCart] = useState(false);
  const [orderSubmitted, setOrderSubmitted] = useState(false);

  const product_quantities_arr: number[] = cart_list.map(
    (item) => item.quantity
  );
  const product_ids_arr: number[] = cart_list.map((item) => item.product_id);
  const addressData = address?.data?.[0];

  console.log(cart_list);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      shipping_name: addressData?.name || '',
      shipping_phone: addressData?.phone || '',
      email: addressData?.email || '',
      shipping_city_id: addressData?.city_id || null,
      shipping_zone_id: addressData?.zone_id || null,
      shipping_area_id: addressData?.area_id || null,
      shipping_address: addressData?.address || '',
      payment_type: 'cash_on_delivery',
      is_preorder: 'web',
      redeem_point: '',
      coupon_code: cartSummary?.coupon_code,
      type: 'web',
      note: '',
    },
  });

  const onSubmit = async (data: any) => {
    try {
      const res = await axios.post(`/api/v2/credential/order-store/v2`, {
        product_quantities_arr,
        product_ids_arr,
        ...data,
        order_source: 'web',
        coupon_code: cartSummary?.coupon_code,
      });
      if (res?.data?.result) {
        setOrderSubmitted(true); // 👈 SET THE STATE HERE
        dispatch(clearCart());
        if (res?.data?.data?.payment_url) {
          router.push(res?.data?.data?.payment_url);
        } else {
          router.push(
            `/order-success?order_id=${res?.data?.data?.order?.id}&message=${res?.data?.message}&result=${res?.data?.result}`
          );
        }
      } else {
        toast.error(res.data.message || 'Order failed');
      }
    } catch (error) {
      toast.error('Order failed');
    }
  };

  useEffect(() => {
    if (!cartLoading && cart_list?.length === 0 && !orderSubmitted) {
      router.push('/shop');
    } else {
      setCheckedCart(true);
    }
  }, [cart_list, router]);

  if (!checkedCart) return null; // Don't render anything until cart is checked

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="row g-5">
      <CheckoutForm
        register={register}
        setValue={setValue}
        errors={errors}
        watch={watch}
      />
      <OrderSummary
        register={register}
        watch={watch}
        cartSummary={cartSummary}
        mutate={mutate}
        isSubmitting={isSubmitting}
      />
    </form>
  );
};

export default CheckoutWrapper;
